export default __webpack_public_path__ + "static/media/learose3-768w.d400fa3e.webp";